import LockIcon from "@mui/icons-material/Lock";
import { Box, Typography, Button, keyframes, useTheme } from "@mui/material";
import { useState, useEffect } from "react";

const redirectUrl = "https://hub.texasmarineagency.info/";

// Animation keyframes
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
    opacity: 0.8;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.8;
  }
`;

const Unauthorized = () => {
  const [countdown, setCountdown] = useState(20);
  const theme = useTheme();

  // Handle redirect
  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          window.location.href = redirectUrl;
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const handleRedirectNow = () => {
    window.location.href = redirectUrl;
  };

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // Dark background with gradient
        background:
          "linear-gradient(135deg, rgba(25, 28, 32, 0.85), rgba(18, 20, 25, 0.9))",
        zIndex: 9999,
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backdropFilter: "blur(12px)",
          zIndex: -1,
        },
        "&::after": {
          content: '""',
          position: "absolute",
          width: "150%",
          height: "150%",
          top: "-25%",
          left: "-25%",
          // background: "radial-gradient(circle, rgba(255,255,255,0.03) 0%, rgba(255,255,255,0) 70%)",
          // background: "linear-gradient(135deg, rgba(100, 102, 103, 0.07), rgba(190, 200, 215, 0.5))",
          backgroundColor: "rgba(255, 255, 255, 0.65)",
          transform: "rotate(-12deg)",
          zIndex: -1,
        },
      }}
    >
      {/* Glass morphism card */}
      <Box
        sx={{
          width: { xs: "90%", sm: "500px" },
          padding: "2rem",
          borderRadius: "16px",
          // Light theme glass effect
          backgroundColor: "rgb(255, 255, 255)",
          backdropFilter: "blur(20px)",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 3,
          animation: `${fadeIn} 0.8s ease-out forwards`,
        }}
      >
        {/* Pulsing lock icon */}
        <Box
          sx={{
            width: 70,
            height: 70,
            borderRadius: "50%",
            backgroundColor: `${theme.palette.primary.light}20`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            animation: `${pulse} 2s infinite`,
          }}
        >
          <LockIcon
            sx={{
              fontSize: 35,
              color: theme.palette.primary.main,
            }}
          />
        </Box>

        <Typography
          variant="h5"
          sx={{
            color: theme.palette.text.primary,
            fontWeight: "bold",
            textAlign: "center",
          }}
        >
          Access Restricted
        </Typography>

        <Typography
          sx={{
            color: theme.palette.text.secondary,
            textAlign: "center",
            mb: 1,
          }}
        >
          Please sign in through your organization’s portal. <br />
          Redirecting to the portal in{" "}
          <Box component="span" sx={{ color: theme.palette.primary.main }}>
            {countdown}
          </Box>{" "}
          seconds.
        </Typography>

        <Button
          variant="contained"
          onClick={handleRedirectNow}
          color="primary"
          sx={{
            mt: 1,
            bgcolor: theme.palette.primary.main,
            color: theme.palette.primary.contrastText,
            textTransform: "none",
            px: 4,
            py: 1,
            "&:hover": {
              bgcolor: theme.palette.primary.dark,
            },
          }}
        >
          Redirect Now
        </Button>
      </Box>
    </Box>
  );
};

export default Unauthorized;
